module.exports = __webpack_public_path__ + "first-100-microprint.jpg?de77780d9aebc1508efa67ec4939b21d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-100-microprint.jpg
// module id = 417
// module chunks = 0